<template>
    <div class="preview-body">
        <div v-if="!showPageLoader">
            <div class="customer-info">
                <div class="customers-info-section">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="filter-section sub-filter">
                                <div class="row sup-heading">
                                    <div class="col-md-12 sup-heading-content">
                                        <h2 class="m-0">Preview Profile</h2>
                                        <b-button
                                            size="sm"
                                            variant="secondary"
                                            @click="pdf"
                                        >
                                            Export as PDF
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <ul>
                                <li>
                                    <div class="seprator-section">
                                        <div class="row">
                                            <div
                                                v-for="(field, index) in fields"
                                                v-if="
                                                    field.section ==
                                                    'setup-profile'
                                                "
                                                :key="index"
                                                :class="{
                                                    [field.class]: true,
                                                    'col-lg-12':
                                                        field.type == 'heading',
                                                    'col-md-6':
                                                        field.type !==
                                                            'heading' &&
                                                        !field.class,
                                                    'col-md-8':
                                                        (index == 4 ||
                                                            index == 6) &&
                                                        section ==
                                                            'account-info',
                                                }"
                                            >
                                                <div
                                                    v-if="
                                                        field.type == 'heading'
                                                    "
                                                >
                                                    <h3>{{ field.label }}</h3>
                                                </div>
                                                <div v-else>
                                                    <hr
                                                        v-if="
                                                            [
                                                                'multi-text-field',
                                                                'multi-field',
                                                            ].includes(
                                                                field.type
                                                            )
                                                        "
                                                    />

                                                    <div
                                                        v-if="
                                                            [
                                                                'multi-text-field',
                                                                'multi-field',
                                                            ].includes(
                                                                field.type
                                                            )
                                                        "
                                                        class="row"
                                                    >
                                                        <div class="col-md-12">
                                                            <label>{{
                                                                showLabel(field)
                                                            }}</label>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <ul
                                                                v-for="(
                                                                    item,
                                                                    subIndex
                                                                ) in field.multiOptions"
                                                                class="row"
                                                            >
                                                                <li
                                                                    class="col-md-6"
                                                                >
                                                                    <label>{{
                                                                        showLabel(
                                                                            item
                                                                        )
                                                                    }}</label>
                                                                </li>
                                                                <li
                                                                    class="col-md-6"
                                                                >
                                                                    <span
                                                                        class=""
                                                                        >{{
                                                                            showValue(
                                                                                customerDetails,
                                                                                field,
                                                                                item
                                                                            )
                                                                        }}</span
                                                                    >
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <ul v-else class="row">
                                                        <li class="col-md-6">
                                                            <label>{{
                                                                showLabel(field)
                                                            }}</label>
                                                        </li>
                                                        <li class="col-md-6">
                                                            <span class="">{{
                                                                showValue(
                                                                    customerDetails,
                                                                    field
                                                                )
                                                            }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <hr
                                                    v-if="
                                                        [
                                                            'multi-text-field',
                                                            'multi-field',
                                                        ].includes(field.type)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <div class="seprator-section"  v-if="this.configData.accountinfo != false">
                                        <div class="row">
                                            <div
                                                v-for="(field, index) in fields"
                                                v-if="
                                                    field.section ==
                                                    'account-info' 
                                                  
                                                "
                                                :key="index"
                                                :class="{
                                                    [field.class]: true,
                                                    'col-lg-12':
                                                        field.type == 'heading',
                                                    'col-md-6':
                                                        field.type !==
                                                            'heading' &&
                                                        !field.class,
                                                    'col-md-8':
                                                        (index == 4 ||
                                                            index == 6) &&
                                                        section ==
                                                            'account-info',
                                                }"
                                            >
                                                <div
                                                    v-if="
                                                        field.type == 'heading'
                                                    "
                                                >
                                                    <h3>{{ field.label }}</h3>
                                                </div>
                                                <div v-else>
                                                    <!--<hr v-if="['multi-text-field', 'multi-field'].includes(field.type)">-->

                                                    <div
                                                        v-if="
                                                            [
                                                                'multi-text-field',
                                                                'multi-field',
                                                            ].includes(
                                                                field.type
                                                            )
                                                        "
                                                        class="row"
                                                    >
                                                        <div class="col-md-12">
                                                            <label>{{
                                                                showLabel(field)
                                                            }}</label>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <ul
                                                                v-for="(
                                                                    item,
                                                                    subIndex
                                                                ) in field.multiOptions"
                                                                class="row"
                                                            >
                                                                <li
                                                                    class="col-md-6"
                                                                >
                                                                    <label>{{
                                                                        showLabel(
                                                                            item
                                                                        )
                                                                    }}</label>
                                                                </li>
                                                                <li
                                                                    class="col-md-6"
                                                                >
                                                                    <span
                                                                        class=""
                                                                        >{{
                                                                            showValue(
                                                                                customerDetails,
                                                                                field,
                                                                                item
                                                                            )
                                                                        }}</span
                                                                    >
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <ul v-else class="row">
                                                        <li class="col-md-6">
                                                            <label>{{
                                                                showLabel(field)
                                                            }}</label>
                                                        </li>
                                                        <li class="col-md-6">
                                                            <span class="">{{
                                                                showValue(
                                                                    customerDetails,
                                                                    field
                                                                )
                                                            }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <hr
                                                    v-if="
                                                        [
                                                            'multi-text-field',
                                                            'multi-field',
                                                        ].includes(field.type)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                            <ul v-if="configData.documentUpload == true">
                                <li>
                                    <div class="seprator-section">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h3>ID Document</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div
                                                class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4"
                                            >
                                                <img
                                                    v-if="
                                                        identityInfo.fileName &&
                                                        identityInfo.fileName
                                                            .split('.')
                                                            .pop() === 'pdf'
                                                    "
                                                    v-authenticated-image="
                                                        'customer-documents/pdf_icon.png'
                                                    "
                                                    style="
                                                        min-width: 40% !important;
                                                        width: 10% !important;
                                                    "
                                                />

                                                <img
                                                    v-else
                                                    v-authenticated-image="
                                                        'customers/' +
                                                        identityInfo.fileName
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="buttons">
                <b-button
                    size="sm"
                    class="mr-3"
                    variant="secondary"
                    @click="$router.go(-1)"
                >
                    Back
                </b-button>
                <b-button
                    type="button"
                    variant="primary"
                    class="primary-add-btn"
                    :class="loading ? 'disabled' : ''"
                    :disabled="loading"
                    @click="onSubmit"
                    >CONTINUE
                </b-button>
                <span v-if="loading" class="secondary-color">
                    Please wait. We're processing your request...</span
                >
            </div>

            <div class="col-lg-4"></div>
        </div>
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import request from '@/utils/request'
import _ from 'lodash'

export default {
    components: {},

    data() {
        return {
            country: process.env.VUE_APP_COUNTRY,
            fields: [],
            customerDetails: [],
            basicInfo: [],
            residentialInfo: [],
            declarationByCustomer: [],
            pepDeclaration: [],
            ultimateBenefit: [],
            factaDetails: [],
            otpData: null,
            is_data_fetched: false,
            sourceOfWealth: [],
            sourceOfFunds: [],
            identityInfo: null,
            instance: process.env.VUE_APP_COUNTRY,
            configData: [],
            showPageLoader: true,
        }
    },
    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        // ...mapState({
        //     userOcr: (state) => state.registration.useOcr,
        // }),

        ...mapGetters(['dataSegmentId', 'loading', 'form', 'user']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */

    created() {
        this.customerDetails = this.$store.state.registration.form
        this.configData = this.$store.state.registration.configData
        this.getRecords()
        this.identityInfo = this.$store.getters.getField(
            'documentInfo.identity'
        )
    },
    mounted() {
        this.$store.commit('setLoading', false)
    },
    methods: {
      
        showLabel(field, index = '') {
            if (field.key == 'basicInfo.firstName') {
                return 'Company Name'
            }
            if (field.key == 'identityInfo.number') {
                if (process.env.VUE_APP_COUNTRY_TEMP == 'UK') {
                    return 'Company Registration Number'
                }
                else if(process.env.VUE_APP_COUNTRY_TEMP == "PK"){
                    return 'NTN number / Registration Number'
                }
                return 'Company Registration / Trade License Number'
            }
            if (field.key == 'identityInfo.passport.number') {
                       
                       if(process.env.VUE_APP_COUNTRY_TEMP == "PK"){
                           return 'CUIN Number / Registration Number'
                       }
                   }
            if (field.key == 'basicInfo.dateOfBirth') {
                return 'Date of Incorporation'
            }
            if (field.key == 'identityInfo.expiryDate') {
                if (process.env.VUE_APP_COUNTRY_TEMP == 'UK') {
                    return 'Company Registration Expiry'
                }
                return 'Company Registration / Trade License expiry date'
            }
            if (
                field.key == 'basicInfo.nationalityId' ||
                field.label == 'Nationality'
            ) {
                return 'Country of Operation'
            }
            if (
                field.key == 'basicInfo.countryOfResidenceId' ||
                field.label == 'Country of Residence'
            ) {
                return 'Country of Domicile'
            }
            if (field.key == 'basicInfo.hasOtherNationalities') {
                return 'Do you operate in other countries?'
            }
            if (field.key == 'basicInfo.otherNationalities') {
                return 'Specify other countries'
            }
            if (field.key == 'identityInfo.isLifetimeExpiry') {
                return 'Do you have a Company Reg expiry date?'
            }
            if (field.key == 'sourceOfFunds.OtherEvidenced') {
                return "Enter details of Company's Source of Funds"
            } else {
                return field.label
            }
        },
        showValue(customerDetails, field, subItem = '') {
            // console.log('customer details',customerDetails)
            if (field.type == 'multi-field') {
                let temp = customerDetails.dynamicInputValues[field.key]
                    ? customerDetails.dynamicInputValues[field.key]
                    : []
                let childKey = subItem.key
                if (temp.length > 0) {
                    const values = temp.map((obj) =>
                        this.showValue(
                            obj,
                            field.multiOptions.find((el) => el.key == childKey)
                        )
                    )
                    return values.join(', ')
                }
                return 'N/A'
            }
            if (field.type == 'multi-text-field') {
                let temp = customerDetails.dynamicInputValues[field.key]
                    ? customerDetails.dynamicInputValues[field.key]
                    : []
                let tempKey = subItem.key
                if (temp.length > 0) {
                    const values = temp.map((obj) => obj[tempKey])
                    return values.join(', ')
                }
                return 'N/A'
            }
            let fieldName = field.key
            if (field.isAssociation) {
                field.key = field.key.replace('Id', '')
            }
            let value = customerDetails[fieldName]
                ? customerDetails[fieldName]
                : ''

            if (field.key.includes('.')) {
                fieldName = field.key.split('.')
                value = _.get(customerDetails,field.key)
                    ? _.get(customerDetails,field.key)
                    : ''
            }

            if (value != '' && value != null && value != undefined) {
                if (field.type == 'date-picker') {
                    value = this.$moment(value).format('MMM D, Y')
                }
                if (
                    field.type == 'other-nationalities' ||
                    field.type == 'multi-select'
                ) {
                    value = value.map((item) => item.title)
                }
                // if(field.isAssociation)
                // {
                //     // value= this.fetchTitle(field.association,value)
                //     Promise.resolve(this.fetchTitle(field.association, value))
                //         .then(resolvedValue => {
                //             value = resolvedValue;
                //             return value
                //         })
                //         .catch(error => {
                //             console.log(error);
                //         });
                // }
                if (field.type == 'phone-number') {
                    let isdCodeKey = field.key.split('.').slice(0, -1)
                    isdCodeKey = isdCodeKey.join('.')+'.isdCode'
                    return (
                        _.get(customerDetails,isdCodeKey) + ' ' + value
                    )
                }
                if (field.type == 'base-file-input') {
                    return value ? value.originalFileName : 'N/A'
                }

                return value
            }
            return 'N/A'
        },
        async onSubmit() {
            this.$store.commit('setLoading', true)
            const formData = this.$store.state.registration.form
            formData.dataSegmentId = this.dataSegmentId
            let registrationUrl = '/customers/face-to-face'
            if (this.$route.meta.publicRegistration === true) {
                registrationUrl = '/customers/non-face-to-face'
            }
            try {
                const formData = this.$store.state.registration.form
                formData.dataSegmentId = this.dataSegmentId
                formData.type = 'company'

                // Update Fields Source of funds/wealth Docs
                this.$store.commit('updateField', {
                    key: 'documentInfo.fundsEvidenceDocument',
                    value: this.$store.getters.getField(
                        'sourceOfFunds.evidenceDocument'
                    ),
                })
                this.$store.commit('updateField', {
                    key: 'documentInfo.wealthEvidenceDocument',
                    value: this.$store.getters.getField(
                        'sourceOfWealth.evidenceDocument'
                    ),
                })
                this.$store.commit('updateField', {
                    key: 'isSelfServiceRegistraion',
                    value: true,
                })

                let eddKeysToDelete = ['accountInfo.enhancedDueDiligence','documentInfo.scrutiny','documentInfo.custBusInquired',
                                       'documentInfo.managementApproval','documentInfo.firstPayment',]
                for(let i=0 ; i < eddKeysToDelete.length ; i++){
                    this.$store.commit('updateField', {
                    key: eddKeysToDelete[i],
                    value: null,
                })
                }
                let encryptedForm = this.$encrypt(formData)
                const tempRequest = { data: encryptedForm }
                const { data } = await request({
                    url: registrationUrl,
                    method: 'post',
                    data: tempRequest,
                })

                // console.log('FormData: ' + JSON.stringify(formData))
                // const { data } = await request({
                //     url: registrationUrl,
                //     method: 'post',
                //     data: formData,
                // })
                this.$store.commit('updateField', {
                    key: 'idenfoId',
                    value: data.data.idenfoId,
                })

                if (data.warning) {
                    this.$store.commit('setValue', {
                        key: 'warning',
                        value: data.warning,
                    })
                }

                this.$router.push({
                    name: 'self-registration-company-finish',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
                this.$store.commit('setLoading', false)
            } catch (errors) {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', errors)

                let allErrors = JSON.parse(JSON.stringify(errors.errors))
                let errorsArray = []
                for (var key in allErrors) {
                    if (allErrors.hasOwnProperty(key)) {
                        errorsArray.push(allErrors[key].message)
                    }
                }
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', errorsArray[0])
            }
        }, // End of otpResponse() method

        pdf() {
            window.print()
            window.close()
        },
        async getRecords() {
            try {
                let { data } = await request({
                    url: `/form-builder/fields`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        visibleTo: 'company',
                        isEdit:false,
                        type:"company",
                        uaepassfield:this.configData.uaepassfield
                    },
                })
                this.showPageLoader = false
                this.fields = data.data
            } catch (error) {
                console.log(error)
            }
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method
        fetchTitle(collection, id) {
            return new Promise((resolve, reject) => {
                request({
                    url: `/form-builder/fetchTitle`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        id: id,
                        collection: collection,
                    },
                })
                    .then(({ data }) => {
                        if (data.data && data.status == 'success') {
                            resolve(data.data)
                        } else {
                            resolve('') // Return an empty string if the response doesn't have the expected data
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        async fetchTitleOld(collection, id) {
            try {
                let { data } = await request({
                    url: `/form-builder/fetchTitle`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        id: id,
                        collection: collection,
                    },
                })
                if (data.data && data.data.status == 'success') {
                    return data.data.data
                }
                return ''
            } catch (error) {
                console.log(error)
            }
            this.$store.commit('setLoading', false)
        },
    },
}
</script>
